import AuthModal from './AuthModal';
import ProfileModal from './ProfileModal';
import HowToPlay from './HowToPlay';

export default function ModalManager({ auth, showProfileModal, onCloseProfile, showHowToPlay, onCloseHowToPlay }) {
  return (
    <>
      {auth.showAuthModal && (
        <AuthModal
          onClose={() => auth.setShowAuthModal(false)}
          onSendCode={auth.sendCode}
          onVerify={auth.verify}
        />
      )}
      {showProfileModal && auth.user && (
        <ProfileModal
          user={auth.user}
          onClose={onCloseProfile}
          onUpdateProfile={auth.updateProfile}
          onDeleteAccount={auth.deleteAccount}
          onSignOut={auth.signOut}
        />
      )}
      {showHowToPlay && <HowToPlay onClose={onCloseHowToPlay} />}
    </>
  );
}
